import accountsService from "services/accounts-service";
import baseEntitiesService from "services/base-entities-service";
import branchesService from "services/branches-service";
import entitiesService from "services/entities-service";

const levelsMap = {
  account: {
    valueProp: "accountId",
    setterProp: "setAccountId",
    labelKey: "account-singular",
    fetch: () => accountsService.getAccounts({ raw: true }),
    parentKey: null, // Root level, no parent
    parentLevel: null,
  },
  branchGroup: {
    valueProp: "branchGroupId",
    setterProp: "setBranchGroupId",
    labelKey: "branch-group-singular",
    fetch: () => branchesService.getBranchGroups({ raw: true }),
    parentKey: "accountId",
    parentLevel: "account",
  },
  branch: {
    valueProp: "branchId",
    setterProp: "setBranchId",
    labelKey: "branch-singular",
    fetch: () => branchesService.getBranches({ raw: true }),
    parentKey: "branchGroupId",
    groupBy: (option) => option.branchGroup?.name,
    parentLevel: "branchGroup",
  },

  baseEntity: {
    valueProp: "baseEntityId",
    setterProp: "setBaseEntityId",
    labelKey: "base-entity-singular",
    fetch: () => baseEntitiesService.getBaseEntities({ raw: true }),
    parentKey: null,
  },
  entity: {
    valueProp: "entityId",
    setterProp: "setEntityId",
    labelKey: "entity-singular",
    fetch: () => entitiesService.getEntities({ raw: true }),
    groupBy: (option) => option.baseEntity?.name,
    parentKey: "baseEntityId",
    parentLevel: "baseEntity",
  },
};

export default levelsMap;
